import type FeatureControlService from 'teacher-ui-client/services/feature-control'
import Component from '@glimmer/component'
import { SideNavProductGroup } from 'teacher-ui-client/components/side-nav/product-group'
import { service } from '@ember/service'
import MathseedsPrimeReportsAccordion from 'teacher-ui-client/components/side-nav/maths/mathseeds-prime-reports-accordion'

export class MathseedsPrimeProductGroup extends Component {
  @service featureControl!: FeatureControlService

  get showMathseedsPrime() {
    return this.featureControl.canAccess('msp_product')
  }

  <template>
    {{#if this.showMathseedsPrime}}
      <SideNavProductGroup @product="mathseeds-prime" class="bg-yellow-25 rounded-lg">
        <MathseedsPrimeReportsAccordion />
      </SideNavProductGroup>
    {{/if}}
  </template>
}
